import type { Buffer } from "../model/buffer";
import { lastLineIndex, lineAt, lineLength } from "../model/buffer";
import type { Cursor } from "../model/cursor";

export type CharClass = "word" | "punct" | "blank";

const WORD_CHAR = /[A-Za-z0-9_]/;

function classifyChar(ch: string): CharClass {
  if (ch === "" || /\s/.test(ch)) {
    return "blank";
  }
  return WORD_CHAR.test(ch) ? "word" : "punct";
}

/** カーソル位置の文字クラス。行末（改行位置）は blank として扱う。 */
export function classAt(buffer: Buffer, pos: Cursor): CharClass {
  const line = lineAt(buffer, pos.line);
  if (pos.col >= line.length) {
    return "blank";
  }
  return classifyChar(line[pos.col] as string);
}

/** バッファ中を読み順で1文字進めた位置。バッファ末尾では null。 */
export function stepForward(buffer: Buffer, pos: Cursor): Cursor | null {
  const length = lineLength(buffer, pos.line);
  if (pos.col < length) {
    return { line: pos.line, col: pos.col + 1 };
  }
  if (pos.line < lastLineIndex(buffer)) {
    return { line: pos.line + 1, col: 0 };
  }
  return null;
}

/** バッファ中を読み順で1文字戻した位置。バッファ先頭では null。 */
export function stepBackward(buffer: Buffer, pos: Cursor): Cursor | null {
  if (pos.col > 0) {
    return { line: pos.line, col: pos.col - 1 };
  }
  if (pos.line > 0) {
    const prevLine = pos.line - 1;
    return { line: prevLine, col: lineLength(buffer, prevLine) };
  }
  return null;
}
